/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CallsAliases {
  ACTION_NEW_CALL = 'action-new-call',
  AVATAR_0 = 'avatar-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_CALLS = 'deck-calls',
  FETCH_CALLS = 'fetch-calls',
  FIELD_ACCREDITATION = 'field-accreditation',
  FIELD_CALL_TYPE = 'field-call-type',
  HPMS_CUSTOM_CARD_CALLS = 'hpms-custom-card-calls',
  MAPPER_0 = 'mapper-0',
  PANEL_0 = 'panel-0',
  PANEL_CALLS = 'panel-calls',
  TEXT_0 = 'text-0',
}
export { CallsAliases };
